import { useState } from 'react'
import { AlertTriangle, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'
import { toast } from 'sonner'
import api from '@/services/api'

export function DeleteConfirmationModal({
  open,
  onClose,
  dealId,
  dealName,
  onDeleted,
}: {
  open: boolean
  onClose: () => void
  dealId: string
  dealName: string
  onDeleted?: (dealId: string) => void
}) {
  const [reason, setReason] = useState('')
  const [notes, setNotes] = useState('')
  const [deleting, setDeleting] = useState(false)

  const reasons = [
    'Duplicado',
    'Qualificação insuficiente',
    'Sem interesse',
    'Dados incorretos',
    'Troca de closer',
    'Outro',
  ]

  const handleDelete = async () => {
    setDeleting(true)
    try {
      await api.delete(`/deals/${dealId}`, {
        data: { reason, notes },
      })
      onDeleted?.(dealId)
      onClose()
    } catch {
      toast.error('Erro ao excluir deal')
    } finally {
      setDeleting(false)
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="Excluir Deal" size="sm">
      <div className="space-y-4">
        <div className="flex items-center gap-3 p-3 rounded-md bg-red-400/5 border border-red-400/10">
          <AlertTriangle size={20} className="text-red-400 shrink-0" />
          <div>
            <p className="text-sm font-medium text-text-primary">Tem certeza?</p>
            <p className="text-xs text-text-label">
              Isso removerá permanentemente o deal <strong>{dealName}</strong> e todos os seus dados associados.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-[10px] text-text-label uppercase tracking-wider font-medium">Motivo</label>
          <select
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full bg-white/[0.04] border border-white/[0.06] text-text-primary text-sm rounded-md px-3 py-2 outline-none focus:border-accent cursor-pointer"
          >
            <option value="">Selecionar motivo...</option>
            {reasons.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-[10px] text-text-label uppercase tracking-wider font-medium">Observações</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            placeholder="Detalhes adicionais sobre a exclusão..."
            className="w-full bg-white/[0.04] border border-white/[0.06] text-text-primary text-sm rounded-md px-3 py-2 outline-none focus:border-accent resize-none"
          />
        </div>

        <div className="flex gap-2 pt-2">
          <Button variant="secondary" size="sm" onClick={onClose} className="flex-1">
            Cancelar
          </Button>
          <Button
            variant="destructive"
            size="sm"
            icon={<Trash2 size={13} />}
            loading={deleting}
            onClick={handleDelete}
            className="flex-1"
          >
            Confirmar Exclusão
          </Button>
        </div>
      </div>
    </Modal>
  )
}
